import { createContext, MutableRefObject, useEffect, useRef, useState } from "react";

interface UsePortal {
  portalRef: MutableRefObject<HTMLElement | null>;
  portalRefElement: HTMLElement | null;
}
export function usePortal(): UsePortal {
  const portalRef = useRef<HTMLElement | null>(null);
  const [portalRefElement, setPortalRefElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalRefElement(portalRef.current);
  }, [portalRef.current]);

  return { portalRef, portalRefElement };
}

export const PortalContext = createContext<UsePortal>(null!);
